
import React, { useEffect, useRef, useState } from "react";
import { Loader } from '../../components';
import { Banner, ConfigShirt } from '../../components';


const ExperienceConfigurator = (props) => {
  const heroImg = require('../../assets/header-experience.jpg');
  const arrayLoad = [
    heroImg
  ]
  return(
    <React.Fragment>
      <ConfigShirt />
      <div className="side--quote-wrap no-margin-btm">
        <div className="side--title">
          <h6 className="md--title">Empower your ecommerce</h6>
          <img src={require('../../assets/3dexperience/logo_3DCommerce.jpg')} />
        </div>
        <p className="preset-9 side--text">
          We transform your online fashion goods into Full Reality 3D models to bring the digital experience to the highest level. 
          <br/><br/>
          Manipulate and change every detail of your products come to life, thanks to our house blend of advanced digitization techniques.</p>
      </div>
      <Banner 
          text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" 
        />
      <Loader arrayLoad={arrayLoad} />
    </React.Fragment>
  )
}

export default ExperienceConfigurator